import React from "react"

import { Form, Formik, FormikHelpers } from "formik"
import * as Yup from "yup"

import { gql, useMutation } from "hooks/urql"

import {
  AutocompleteField,
  FormFailures,
  SubmitButton,
  handleFailure,
} from "components/Forms/Formik/hookComponents"

type AddStudentsFormState = {
  studentIds: string[]
}

type AddStudentsProps = {
  acrClassId: string
  schoolId: string
}

const ValidationSchema = Yup.object().shape({
  studentIds: Yup.array().min(1, "At least 1 student is required"),
})

const AddStudents: React.FC<AddStudentsProps> = ({ acrClassId, schoolId }) => {
  const [, addStudents]: any[] = useMutation(addStudentsMutation)

  const formState: AddStudentsFormState = { studentIds: [] }

  const handleSubmit = (
    values: AddStudentsFormState,
    actions: FormikHelpers<AddStudentsFormState>
  ) => {
    addStudents({ acrClassId, studentIds: values.studentIds })
      .then((result: any) => {
        const { failures } = result.data.addAcrClassStudents
        if (failures.length > 0) {
          handleFailure(actions, failures)
        } else {
          window.location.reload()
        }
      })
      .catch(() => handleFailure(actions))
  }

  return (
    <Formik
      initialValues={formState}
      onSubmit={handleSubmit}
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={ValidationSchema}
    >
      <Form>
        <AutocompleteField
          name="studentIds"
          label="Add Students"
          api="/api/admins/students/autocomplete_full_name"
          searchOptions={`school_id=${schoolId}`}
          isMulti
        />
        <FormFailures />
        <SubmitButton text="Add Students" />
      </Form>
    </Formik>
  )
}

const addStudentsMutation = gql`
  mutation ($acrClassId: ID!, $studentIds: [ID!]!) {
    addAcrClassStudents(acrClassId: $acrClassId, studentIds: $studentIds) {
      failures {
        message
      }
    }
  }
`

export default AddStudents
